const MENU_PERMISSIONS_LIST = [
  {
    code: 'MAINPAGE',
    linkData: {
      path: 'admin/main',
      title: 'sidebar.admin.main',
    },
    iconName: 'bi bi-house',
    order: 1,
  },
  {
    code: 'DASHBOARD',
    linkData: {
      path: 'admin/dashboard',
      title: 'sidebar.admin.dashboard',
    },
    iconName: 'bi bi-clipboard-data',
    order: 2,
  },
  {
    code: 'HOMES',
    linkData: {
      path: 'admin/homes',
      title: 'sidebar.admin.homes',
    },
    iconName: 'bi bi-houses',
    order: 3,
  },
  {
    code: 'ORDER',
    linkData: {
      path: 'admin/order',
      title: 'sidebar.admin.order',
    },
    iconName: 'bi bi-stopwatch',
    order: 4,
  },
  // {
  //   code: 'OBJECTS',
  //   linkData: {
  //     path: 'admin/object',
  //     title: 'sidebar.admin.object',
  //   },
  //   iconName: 'bi bi-houses',
  //   order: 6,
  // },
  {
    code: 'CONTRACTS',
    linkData: {
      path: 'admin/contract',
      title: 'sidebar.admin.contract',
    },
    iconName: 'bi bi-clipboard-check',
    order: 5,
  },
  {
    code: 'PAYMENTS',
    linkData: {
      path: 'admin/payment',
      title: 'sidebar.admin.payment',
    },
    iconName: 'bi bi-cash-coin',
    order: 6,
  },
  {
    code: 'CUSTOMS',
    linkData: {
      path: 'admin/client',
      title: 'sidebar.admin.client',
    },
    iconName: 'bi bi-people',
    order: 7,
  },
  // {
  //   code: 'NEWS',
  //   linkData: {
  //     path: 'admin/news',
  //     title: 'sidebar.admin.news',
  //   },
  //   iconName: 'bi bi-newspaper',
  //   order: 7,
  // },
  {
    code: 'DEBITORS',
    linkData: {
      path: 'admin/arrears',
      title: 'sidebar.admin.arrears',
    },
    iconName: 'bi bi-cash-stack',
    order: 8,
  },
  {
    code: 'CHANGES',
    linkData: {
      path: 'admin/change',
      title: 'sidebar.admin.change',
    },
    iconName: 'bi bi-arrow-repeat',
    order: 9,
  },
  // {
  //   code: 'PAYMENTS_CHANGES',
  //   linkData: {
  //     path: 'admin/payment-change',
  //     title: 'sidebar.admin.paymentChange',
  //   },
  //   iconName: 'bi bi-cash-stack',
  //   order: 13,
  // },
  {
    code: 'TASKS',
    linkData: {
      path: 'admin/tasks',
      title: 'sidebar.admin.tasks',
    },
    iconName: 'bi bi-journal-bookmark',
    order: 10,
  },
  {
    code: 'CRM',
    linkData: {
      path: 'admin/crm',
      title: 'sidebar.admin.crm',
    },
    iconName: 'bi bi-grid-1x2',
    order: 11,
  },
  // {
  //   code: 'OBJECTS',
  //   linkData: {
  //     path: 'admin/block',
  //     title: 'sidebar.admin.block',
  //   },
  //   iconName: 'bi bi-buildings',
  //   order: 16,
  // },
  {
    code: 'STATISTICS',
    bottom: true,
    linkData: {
      path: 'boss/dashboard',
      title: 'sidebar.admin.boss',
    },
    iconName: 'bi bi-person-workspace',
    order: 12,
  },
  // {
  //   code: 'SHOWROOM',
  //   bottom: true,
  //   linkData: {
  //     path: 'admin/shaxmatka',
  //     title: 'sidebar.admin.shaxmatka',
  //   },
  //   iconName: 'bi bi-grid-3x3-gap',
  //   order: 13,
  // },
  {
    code: 'SHOWROOM',
    bottom: true,
    linkData: {
      path: 'admin/showroom',
      title: 'sidebar.admin.showroom',
    },
    iconName: 'bi bi-grid-3x3-gap',
    order: 14,
  },
  {
    code: 'SETTINGS',
    bottom: true,
    linkData: {
      path: 'admin/settings',
      title: 'sidebar.admin.settings',
    },
    iconName: 'bi bi-gear',
    order: 15,
  },
];

export default MENU_PERMISSIONS_LIST;
